import { render, staticRenderFns } from "./resetPasswordDialog.vue?vue&type=template&id=19dc4340&scoped=true&"
import script from "./resetPasswordDialog.vue?vue&type=script&lang=js&"
export * from "./resetPasswordDialog.vue?vue&type=script&lang=js&"
import style0 from "./resetPasswordDialog.vue?vue&type=style&index=0&id=19dc4340&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19dc4340",
  null
  
)

export default component.exports